var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.794,
    height: 50,
    viewBox: "0 0 54.794 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cloud-drizzle",
    transform: "translate(0.75 0.752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91198",
    "data-name": "Path 91198",
    d: "M36.017,47.89H35.9a1.019,1.019,0,0,1,.015-2.038,13.1,13.1,0,0,0,8.93-3.43l.015-.013A12.622,12.622,0,0,0,48.4,29a12.593,12.593,0,0,0-10.413-9.11,1.019,1.019,0,0,1-.879-.845C36,12.3,32.328,7.64,26.773,5.923a16.483,16.483,0,0,0-16.433,4.283c-4.042,4.227-5,10.1-2.684,16.544a1.019,1.019,0,1,1-1.919.688,19.9,19.9,0,0,1-1.031-10.66A16.052,16.052,0,0,1,8.867,8.8,18.564,18.564,0,0,1,27.375,3.976a15.944,15.944,0,0,1,7.482,4.937,19.582,19.582,0,0,1,4.134,9.07A14.651,14.651,0,0,1,50.352,28.4a15.6,15.6,0,0,1,.293,8.2,14.062,14.062,0,0,1-4.433,7.33A15.134,15.134,0,0,1,36.017,47.89Z",
    transform: "translate(2.985 -3.958)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91199",
    "data-name": "Path 91199",
    d: "M11.63,33.636l-.073,0a10.749,10.749,0,0,1-7.665-3.7,11.429,11.429,0,0,1,0-14.42,10.755,10.755,0,0,1,7.667-3.691c.076-.005.152,0,.228,0A10.731,10.731,0,0,1,16.637,13a1.019,1.019,0,0,1-.925,1.816,8.675,8.675,0,0,0-4.039-.953A8.556,8.556,0,0,0,3.367,22.72,8.567,8.567,0,0,0,11.7,31.6a1.019,1.019,0,0,1-.071,2.036Z",
    transform: "translate(-2.079 10.322)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91200",
    "data-name": "Path 91200",
    d: "M16.09,11.858a1.019,1.019,0,0,1-.457-1.931,11.2,11.2,0,0,1,4.851-1.2,1.019,1.019,0,0,1,.035,2.038,9.177,9.177,0,0,0-3.974.982A1.015,1.015,0,0,1,16.09,11.858Z",
    transform: "translate(20.707 5.199)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91201",
    "data-name": "Path 91201",
    d: "M8.239,26.6a1.019,1.019,0,0,1-.721-1.74l5.316-5.316a1.019,1.019,0,1,1,1.441,1.441L8.96,26.306A1.016,1.016,0,0,1,8.239,26.6Z",
    transform: "translate(7.69 22.644)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91202",
    "data-name": "Path 91202",
    d: "M12.239,26.6a1.019,1.019,0,0,1-.721-1.74l5.316-5.316a1.019,1.019,0,0,1,1.441,1.441L12.96,26.306A1.016,1.016,0,0,1,12.239,26.6Z",
    transform: "translate(14.323 22.644)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91203",
    "data-name": "Path 91203",
    d: "M12.239,22.6a1.019,1.019,0,0,1-.721-1.74l5.316-5.316a1.019,1.019,0,1,1,1.441,1.441L12.96,22.306A1.016,1.016,0,0,1,12.239,22.6Z",
    transform: "translate(14.323 16.011)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91204",
    "data-name": "Path 91204",
    d: "M8.239,22.6a1.019,1.019,0,0,1-.721-1.74l5.316-5.316a1.019,1.019,0,1,1,1.441,1.441L8.96,22.306A1.016,1.016,0,0,1,8.239,22.6Z",
    transform: "translate(7.69 16.011)",
    fill: "#09143a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlood);
export default __webpack_public_path__ + "static/media/flood.d55bb60da0078cd98f475067da0dbe2b.svg";
export { ForwardRef as ReactComponent };